import ResetPassword from "pages/AuthPage/components/ResetPassword/ResetPassword";

export default ResetPassword;
